/** The business being billed, when the payer is a business. */
export const getInvoicePayerBusinessId = (invoice) => invoice?.toUser?.userType === 'BUSINESS' ? invoice.toUser.userId : undefined;
/**
 * The business an invoice belongs to: the payer when a business is billed (a fee
 * invoice), otherwise the issuer, for an invoice a business raised itself.
 */
export const getInvoiceBusinessId = (invoice) => getInvoicePayerBusinessId(invoice) ??
    (invoice?.fromUser?.userType === 'BUSINESS'
        ? invoice.fromUser.userId
        : undefined);
//# sourceMappingURL=businessInvoiceUtils.js.map